
import Vue from 'vue';
export default Vue.extend({
  name: 'Header',
  data() {
    return {
      menuVisible: false,
      scrolled: 0,
      indexNavbarChanged: false,
    };
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    menuClick() {
      this.menuVisible = !this.menuVisible;
    },
    handleScroll() {
      this.scrolled = window.scrollY;
      if (this.$route.meta?.redHeader) {
        const screenWidth = window.innerWidth;
        if (screenWidth < 640 && this.scrolled > 0.1 * screenWidth) {
          this.indexNavbarChanged = true;
        } else if (screenWidth > 640 && this.scrolled > 0.04 * screenWidth) {
          this.indexNavbarChanged = true;
        } else {
          this.indexNavbarChanged = false;
        }
      }
    },
  },
  watch: {
    $route() {
      if (this.$route.name !== 'Index') {
        this.indexNavbarChanged = false;
      }
    },
  },
});
